import "@/App.css";
import JoieDauphinPage from "./pages/JoieDauphinPage";

function App() {
  return (
    <div className="App">
      <JoieDauphinPage />
    </div>
  );
}

export default App;
